<template>
  <ResponsiveModal
    variant="modal"
    size="default"
    :showFooter="false"
    :title="t('admin.views.actions.title')"
  >
    <template #content>
      <div class="p-4 md:p-0 flex flex-col gap-2">
        <Button
          :size="!maxSmall ? 'lg' : 'xl'"
          variant="secondary"
          :label="t('components.buttons.rename')"
          @click="emit('openRenameDialog')"
        >
          <template #start>
            <Icon name="edit-pen" />
          </template>
        </Button>
        <Button
          :size="!maxSmall ? 'lg' : 'xl'"
          variant="primary"
          type="destructive"
          :label="t('components.buttons.delete')"
          @click="emit('openDeleteDialog')"
        >
          <template #start>
            <Icon name="delete" />
          </template>
        </Button>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { useI18n } from "vue-i18n";
import { Button } from "@/SharedComponents/Buttons";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { t } = useI18n();
const { maxSmall } = useBreakpoints();

const emit = defineEmits(["openRenameDialog", "openDeleteDialog"]);
</script>
